import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitAppointmentServiceRequestDetails = ({
  appointmentServiceRequest,
  handleFileDownload,
}) => {
    console.log("VisitAppointmentServiceRequestDetails")
  const { t } = useTranslation();

  if (!appointmentServiceRequest) return null;

  const { date, institution, practitioner, specialist, file } =
    appointmentServiceRequest;

  return (
    <Card>
      <CardHeader>
        <Heading variant="userAccountDetailsTitle">
          {t('userAccount.registrationsTab.siuntimas')}
        </Heading>
      </CardHeader>
      <CardContent className="space-y-2">
        <div>
          <span>{t('userAccount.registrationsTab.referralData.date')} </span>
          <span>
            {new Date(Date.parse(date)).getUTCHours() === 0 ? (
              <Moment utc format="YYYY-MM-DD">
                {Date.parse(date)}
              </Moment>
            ) : (
              <Moment utc format="YYYY-MM-DD HH:mm">
                {Date.parse(date)}
              </Moment>
            )}
          </span>
        </div>

        <div>
          <span>{t('userAccount.registrationsTab.referralData.institution')} </span>
          <span>{institution}</span>
        </div>

        {practitioner && (
          <div>
            <span>{t('userAccount.registrationsTab.referralData.specialist')} </span>
            <span>{specialist}</span>
          </div>
        )}

        {file?.guid && (
          <div>
            <Button
              variant="light"
              onClick={() => {
                const fileName = `${institution} ${moment(new Date(date)).format('YYYY-MM-DD')}`;
                handleFileDownload(fileName, file.type, file.guid);
              }}
            >
              <Download />
              Atsisiųsti PDF
            </Button>
          </div>
        )}
      </CardContent>
      <CardFooter />
    </Card>
  );
};
